
export const AppMenus = {
    
	navbarTopRightItems: [],
	navbarTopLeftItems: [],
	navbarSideLeftItems: [
  {
    "path": "/cis_agendamento",
    "label": "Cis Agendamento",
    "icon": "extension",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/tb_cbo",
    "label": "Tb Cbo",
    "icon": "extension",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/tb_cidadao",
    "label": "Munícipes",
    "icon": "people",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/tb_escolaridade",
    "label": "Tb Escolaridade",
    "icon": "extension",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/tb_estado_civil",
    "label": "Tb Estado Civil",
    "icon": "extension",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/tb_etnia",
    "label": "Tb Etnia",
    "icon": "extension",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/tb_localidade",
    "label": "Tb Localidade",
    "icon": "extension",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/tb_pais",
    "label": "Tb Pais",
    "icon": "extension",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/tb_raca_cor",
    "label": "Tb Raca Cor",
    "icon": "extension",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/tb_tipo_logradouro",
    "label": "Tb Tipo Logradouro",
    "icon": "extension",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/tb_uf",
    "label": "Tb Uf",
    "icon": "extension",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/users",
    "label": "Users",
    "icon": "extension",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/roles",
    "label": "Roles",
    "icon": "extension",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/permissions",
    "label": "Permissions",
    "icon": "extension",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/humanizacao",
    "label": "Estatísticas",
    "icon": "timeline",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/cis_satisfacao",
    "label": "Lista individual",
    "icon": "insert_emoticon",
    "iconcolor": "",
    "target": "",
    "submenu": []
  },
  {
    "path": "/cis_satisfacao/add",
    "label": "Realizar pesquisa",
    "icon": "note_add",
    "iconcolor": "",
    "target": "",
    "submenu": []
  }
],
	CisAgendamentoListHeaderItems: [
  {
    "label": "Atualizado Em",
    "align": "left",
    "sortable": false,
    "name": "atualizado_em",
    "field": "atualizado_em"
  },
  {
    "label": "Municipe",
    "align": "left",
    "sortable": false,
    "name": "municipe",
    "field": "municipe"
  },
  {
    "label": "Data Consulta",
    "align": "left",
    "sortable": false,
    "name": "data_consulta",
    "field": "data_consulta"
  },
  {
    "label": "Inserido Em",
    "align": "left",
    "sortable": false,
    "name": "inserido_em",
    "field": "inserido_em"
  },
  {
    "label": "Id",
    "align": "left",
    "sortable": false,
    "name": "id",
    "field": "id"
  },
  {
    "label": "Urgencia",
    "align": "left",
    "sortable": false,
    "name": "urgencia",
    "field": "urgencia"
  },
  {
    "label": "Status",
    "align": "left",
    "sortable": false,
    "name": "status",
    "field": "status"
  },
  {
    "label": "Data Pedido",
    "align": "left",
    "sortable": false,
    "name": "data_pedido",
    "field": "data_pedido"
  },
  {
    "label": "Data Entrada",
    "align": "left",
    "sortable": false,
    "name": "data_entrada",
    "field": "data_entrada"
  },
  {
    "label": "Data Realizacao",
    "align": "left",
    "sortable": false,
    "name": "data_realizacao",
    "field": "data_realizacao"
  },
  {
    "label": "Tipo",
    "align": "left",
    "sortable": false,
    "name": "tipo",
    "field": "tipo"
  },
  {
    "label": "Especialidade",
    "align": "left",
    "sortable": false,
    "name": "especialidade",
    "field": "especialidade"
  },
  {
    "label": "Inserido Por",
    "align": "left",
    "sortable": false,
    "name": "inserido_por",
    "field": "inserido_por"
  },
  {
    "label": "",
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],
	CisSatisfacaoListHeaderItems: [
  {
    "label": "Média de satisfação",
    "align": "left",
    "sortable": false,
    "name": "media",
    "field": "media"
  },
  {
    "label": "Coletado",
    "align": "left",
    "sortable": false,
    "name": "inserido_em",
    "field": "inserido_em"
  },
  {
    "label": "Considerações",
    "align": "left",
    "sortable": false,
    "name": "extra",
    "field": "extra"
  },
  {
    "label": "",
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],
	atend_recepcaoItems: [    
{value: "1", label: "Péssimo"},
	{value: "2", label: "Ruim"},
	{value: "3", label: "Regular"},
	{value: "4", label: "Bom"},
	{value: "5", label: "Ótimo"}
    ],
	PermissionsListHeaderItems: [
  {
    "label": "Permission Id",
    "align": "left",
    "sortable": false,
    "name": "permission_id",
    "field": "permission_id"
  },
  {
    "label": "Role Id",
    "align": "left",
    "sortable": false,
    "name": "role_id",
    "field": "role_id"
  },
  {
    "label": "Permission",
    "align": "left",
    "sortable": false,
    "name": "permission",
    "field": "permission"
  },
  {
    "label": "",
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],
	RolesListHeaderItems: [
  {
    "label": "",
    "align": "left",
    "sortable": false,
    "name": "masterdetailbtn",
    "field": ""
  },
  {
    "label": "Role Id",
    "align": "left",
    "sortable": false,
    "name": "role_id",
    "field": "role_id"
  },
  {
    "label": "Role Name",
    "align": "left",
    "sortable": false,
    "name": "role_name",
    "field": "role_name"
  },
  {
    "label": "",
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],
	SatisfacaoFeedbacksListHeaderItems: [],
	TbCboListHeaderItems: [
  {
    "label": "Co Cbo",
    "align": "left",
    "sortable": false,
    "name": "co_cbo",
    "field": "co_cbo"
  },
  {
    "label": "St Disponivel Lotacao",
    "align": "left",
    "sortable": false,
    "name": "st_disponivel_lotacao",
    "field": "st_disponivel_lotacao"
  },
  {
    "label": "No Cbo",
    "align": "left",
    "sortable": false,
    "name": "no_cbo",
    "field": "no_cbo"
  },
  {
    "label": "No Cbo Filtro",
    "align": "left",
    "sortable": false,
    "name": "no_cbo_filtro",
    "field": "no_cbo_filtro"
  },
  {
    "label": "Co Cbo 2002",
    "align": "left",
    "sortable": false,
    "name": "co_cbo_2002",
    "field": "co_cbo_2002"
  },
  {
    "label": "",
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],
	TbCidadaoListHeaderItems: [
  {
    "label": "No Cidadao",
    "align": "left",
    "sortable": false,
    "name": "no_cidadao",
    "field": "no_cidadao"
  },
  {
    "label": "Nu Cpf",
    "align": "left",
    "sortable": false,
    "name": "nu_cpf",
    "field": "nu_cpf"
  },
  {
    "label": "Nu Telefone Celular",
    "align": "left",
    "sortable": false,
    "name": "nu_telefone_celular",
    "field": "nu_telefone_celular"
  },
  {
    "label": "Nu Telefone Contato",
    "align": "left",
    "sortable": false,
    "name": "nu_telefone_contato",
    "field": "nu_telefone_contato"
  },
  {
    "label": "",
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],
	no_sexoItems: [    
{value: "Male", label: "Male"},
	{value: "Female", label: "Female"}
    ],
	TbEscolaridadeListHeaderItems: [
  {
    "label": "Co Escolaridade",
    "align": "left",
    "sortable": false,
    "name": "co_escolaridade",
    "field": "co_escolaridade"
  },
  {
    "label": "No Escolaridade",
    "align": "left",
    "sortable": false,
    "name": "no_escolaridade",
    "field": "no_escolaridade"
  },
  {
    "label": "No Escolaridade Filtro",
    "align": "left",
    "sortable": false,
    "name": "no_escolaridade_filtro",
    "field": "no_escolaridade_filtro"
  },
  {
    "label": "",
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],
	TbEstadoCivilListHeaderItems: [
  {
    "label": "Co Estado Civil",
    "align": "left",
    "sortable": false,
    "name": "co_estado_civil",
    "field": "co_estado_civil"
  },
  {
    "label": "No Estado Civil",
    "align": "left",
    "sortable": false,
    "name": "no_estado_civil",
    "field": "no_estado_civil"
  },
  {
    "label": "",
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],
	TbEtniaListHeaderItems: [
  {
    "label": "Co Etnia",
    "align": "left",
    "sortable": false,
    "name": "co_etnia",
    "field": "co_etnia"
  },
  {
    "label": "No Etnia",
    "align": "left",
    "sortable": false,
    "name": "no_etnia",
    "field": "no_etnia"
  },
  {
    "label": "Co Etnia Cadsus",
    "align": "left",
    "sortable": false,
    "name": "co_etnia_cadsus",
    "field": "co_etnia_cadsus"
  },
  {
    "label": "",
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],
	TbLocalidadeListHeaderItems: [
  {
    "label": "St Ativo",
    "align": "left",
    "sortable": false,
    "name": "st_ativo",
    "field": "st_ativo"
  },
  {
    "label": "Co Uf",
    "align": "left",
    "sortable": false,
    "name": "co_uf",
    "field": "co_uf"
  },
  {
    "label": "Tp Localidade",
    "align": "left",
    "sortable": false,
    "name": "tp_localidade",
    "field": "tp_localidade"
  },
  {
    "label": "Co Situacao Localidade",
    "align": "left",
    "sortable": false,
    "name": "co_situacao_localidade",
    "field": "co_situacao_localidade"
  },
  {
    "label": "Co Localidade",
    "align": "left",
    "sortable": false,
    "name": "co_localidade",
    "field": "co_localidade"
  },
  {
    "label": "Co Ibge",
    "align": "left",
    "sortable": false,
    "name": "co_ibge",
    "field": "co_ibge"
  },
  {
    "label": "No Localidade Filtro",
    "align": "left",
    "sortable": false,
    "name": "no_localidade_filtro",
    "field": "no_localidade_filtro"
  },
  {
    "label": "Nu Dne",
    "align": "left",
    "sortable": false,
    "name": "nu_dne",
    "field": "nu_dne"
  },
  {
    "label": "No Localidade",
    "align": "left",
    "sortable": false,
    "name": "no_localidade",
    "field": "no_localidade"
  },
  {
    "label": "Nu Cep",
    "align": "left",
    "sortable": false,
    "name": "nu_cep",
    "field": "nu_cep"
  },
  {
    "label": "",
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],
	TbPaisListHeaderItems: [
  {
    "label": "",
    "align": "left",
    "sortable": false,
    "name": "masterdetailbtn",
    "field": ""
  },
  {
    "label": "Co Pais",
    "align": "left",
    "sortable": false,
    "name": "co_pais",
    "field": "co_pais"
  },
  {
    "label": "St Ativo",
    "align": "left",
    "sortable": false,
    "name": "st_ativo",
    "field": "st_ativo"
  },
  {
    "label": "Sg Pais 3",
    "align": "left",
    "sortable": false,
    "name": "sg_pais_3",
    "field": "sg_pais_3"
  },
  {
    "label": "No Pais Portugues",
    "align": "left",
    "sortable": false,
    "name": "no_pais_portugues",
    "field": "no_pais_portugues"
  },
  {
    "label": "No Pais Ingles",
    "align": "left",
    "sortable": false,
    "name": "no_pais_ingles",
    "field": "no_pais_ingles"
  },
  {
    "label": "No Pais Portugues Filtro",
    "align": "left",
    "sortable": false,
    "name": "no_pais_portugues_filtro",
    "field": "no_pais_portugues_filtro"
  },
  {
    "label": "Co Pais Cadsus",
    "align": "left",
    "sortable": false,
    "name": "co_pais_cadsus",
    "field": "co_pais_cadsus"
  },
  {
    "label": "Sg Pais 2",
    "align": "left",
    "sortable": false,
    "name": "sg_pais_2",
    "field": "sg_pais_2"
  },
  {
    "label": "",
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],
	TbRacaCorListHeaderItems: [
  {
    "label": "Co Raca Cor",
    "align": "left",
    "sortable": false,
    "name": "co_raca_cor",
    "field": "co_raca_cor"
  },
  {
    "label": "No Raca Cor",
    "align": "left",
    "sortable": false,
    "name": "no_raca_cor",
    "field": "no_raca_cor"
  },
  {
    "label": "Nu Ms",
    "align": "left",
    "sortable": false,
    "name": "nu_ms",
    "field": "nu_ms"
  },
  {
    "label": "No Identificador",
    "align": "left",
    "sortable": false,
    "name": "no_identificador",
    "field": "no_identificador"
  },
  {
    "label": "Co Raca Cor Cadsus",
    "align": "left",
    "sortable": false,
    "name": "co_raca_cor_cadsus",
    "field": "co_raca_cor_cadsus"
  },
  {
    "label": "",
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],
	TbTipoLogradouroListHeaderItems: [
  {
    "label": "Co Tipo Logradouro",
    "align": "left",
    "sortable": false,
    "name": "co_tipo_logradouro",
    "field": "co_tipo_logradouro"
  },
  {
    "label": "Nu Frequencia",
    "align": "left",
    "sortable": false,
    "name": "nu_frequencia",
    "field": "nu_frequencia"
  },
  {
    "label": "St Ativo",
    "align": "left",
    "sortable": false,
    "name": "st_ativo",
    "field": "st_ativo"
  },
  {
    "label": "Co Tp Logradouro Cadsus",
    "align": "left",
    "sortable": false,
    "name": "co_tp_logradouro_cadsus",
    "field": "co_tp_logradouro_cadsus"
  },
  {
    "label": "No Tipo Logradouro Filtro",
    "align": "left",
    "sortable": false,
    "name": "no_tipo_logradouro_filtro",
    "field": "no_tipo_logradouro_filtro"
  },
  {
    "label": "Nu Dne",
    "align": "left",
    "sortable": false,
    "name": "nu_dne",
    "field": "nu_dne"
  },
  {
    "label": "No Tipo Logradouro",
    "align": "left",
    "sortable": false,
    "name": "no_tipo_logradouro",
    "field": "no_tipo_logradouro"
  },
  {
    "label": "",
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],
	TbUfListHeaderItems: [
  {
    "label": "Co Uf",
    "align": "left",
    "sortable": false,
    "name": "co_uf",
    "field": "co_uf"
  },
  {
    "label": "Co Pais",
    "align": "left",
    "sortable": false,
    "name": "co_pais",
    "field": "co_pais"
  },
  {
    "label": "Sg Uf",
    "align": "left",
    "sortable": false,
    "name": "sg_uf",
    "field": "sg_uf"
  },
  {
    "label": "Nu Dne",
    "align": "left",
    "sortable": false,
    "name": "nu_dne",
    "field": "nu_dne"
  },
  {
    "label": "No Uf",
    "align": "left",
    "sortable": false,
    "name": "no_uf",
    "field": "no_uf"
  },
  {
    "label": "No Identificador",
    "align": "left",
    "sortable": false,
    "name": "no_identificador",
    "field": "no_identificador"
  },
  {
    "label": "",
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],
	UsersListHeaderItems: [
  {
    "label": "Id",
    "align": "left",
    "sortable": false,
    "name": "id",
    "field": "id"
  },
  {
    "label": "Name",
    "align": "left",
    "sortable": false,
    "name": "name",
    "field": "name"
  },
  {
    "label": "Image",
    "align": "left",
    "sortable": false,
    "name": "image",
    "field": "image"
  },
  {
    "label": "Phone",
    "align": "left",
    "sortable": false,
    "name": "phone",
    "field": "phone"
  },
  {
    "label": "Email",
    "align": "left",
    "sortable": false,
    "name": "email",
    "field": "email"
  },
  {
    "label": "User Role Id",
    "align": "left",
    "sortable": false,
    "name": "user_role_id",
    "field": "user_role_id"
  },
  {
    "label": "",
    "align": "right",
    "sortable": false,
    "name": "btnactions",
    "field": ""
  }
],
	Cis_SatisfacaoListSortItems: [{"label":"Média de satisfação","value":""},{"label":"Data de Coleta","value":"inserido_em"},{"label":"Nota da recepção","value":"atend_recepcao"},{"label":"Nota da sala de triagem","value":"sala_triagem"},{"label":"Nota da enfermagem","value":"atend_enfermagem"},{"label":"Nota do tempo de atend","value":"tempo_atendido"},{"label":"Nota da limpeza","value":"limpeza"},{"label":"Nota da gentileza","value":"gentileza"},{"label":"Nota das acomodações","value":"acomodacoes"},{"label":"Nota da frequencia de atend","value":"frequencia"},{"label":"Nota da disposição da equipe","value":"disposicao_equipe"},{"label":"Ordem de cadastro","value":"id"}],

    exportFormats: {
        print: {
			label: 'Print',
			color: 'blue',
            icon: 'print',
            id: 'print',
            ext: '',
        },
        pdf: {
			label: 'Pdf',
			color: 'red',
            icon: 'picture_as_pdf',
            id: 'pdf',
            ext: 'pdf',
        },
        excel: {
			label: 'Excel',
			color: 'green',
            icon: 'grid_on',
            id: 'excel',
            ext: 'xlsx',
        },
        csv: {
			label: 'Csv',
			color: 'teal',
            icon: 'grid_on',
            id: 'csv',
            ext: 'csv',
        },
    },
    
}